module.exports = {
  footerText: 'Copyright Company Name © 2018',
  version: '5.5.8'
}
